import React from 'react'
import styles from './index.module.css'

const PitchPage = () => {
  return (
    <div className={`${styles.formContainer} ${styles.darkBackground}`}>
      <iframe src="https://docs.google.com/forms/d/e/1FAIpQLSfNBxyXMo_5Tbn0tPfbM_5RwvgGba9kwJ3Kc_S8QAmdFKmUcA/viewform">
        Loading…
      </iframe>
    </div>
  )
}

export default PitchPage
